__turbopack_context__.v({
  "brush": "kagdMW_brush",
  "chartBrush": "kagdMW_chartBrush",
  "chartMain": "kagdMW_chartMain",
  "container": "kagdMW_container",
  "xAxisLabel": "kagdMW_xAxisLabel",
  "yAxisLabel": "kagdMW_yAxisLabel",
});
